import { Link } from "react-router-dom";
import { SocialLinks } from "@/components/SocialLinks";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_inbody-powered/artifacts/cgjm5igj_FB%20Cover%20logo.png";

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO} alt="MBBC" className="h-12 w-12 object-contain rounded-lg bg-white p-1" />
            <span className="font-heading font-semibold text-lg">My Best Body Club</span>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed">
            Health · Nutrition · Body Composition. Replacing guesswork with data-driven
            biological data through Bioelectrical Impedance Analysis (BIA) testing and whole-food nutrition.
          </p>
          <SocialLinks className="mt-5" />
        </div>
        <div>
          <h4 className="font-heading font-medium mb-4 text-sm">Members</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/join" className="hover:text-teal transition-colors">Become a Member</Link></li>
            <li><Link to="/faq" className="hover:text-teal transition-colors">FAQs</Link></li>
            <li><a href="/#pricing" className="hover:text-teal transition-colors">Membership Plans</a></li>
            <li><Link to="/login" className="hover:text-teal transition-colors">Member Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-medium mb-4 text-sm">Therapists</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/therapists" className="hover:text-teal transition-colors">Become a Therapist</Link></li>
            <li><a href="/#science" className="hover:text-teal transition-colors">The Science</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} My Best Body Club. All rights reserved.</span>
          <span className="flex items-center gap-4">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-teal transition-colors">Privacy & Cookies</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-teal transition-colors">Terms &amp; Conditions</Link>
            <span>Rooted in metabolic physiology.</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
